import connect from 'components/Shared/connect';
import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';
import { SmallLogo } from 'components/Header/themes/BGH/smallLogo';

interface OwnProps {
  className?: string;
}
interface MergedProps extends OwnProps {
  showSmallLogo: boolean;
  logoUrl: string;
}
export const Logo = connect<MergedProps, OwnProps>(state => ({
  showSmallLogo: isLayout(isMobile, isTablet)(state),
  logoUrl: state.appShell.logoUrl
}))(({ showSmallLogo, logoUrl, className }: MergedProps) => {
  return (
    <a className={className} href="/">
      {showSmallLogo ? <SmallLogo /> : <img style={{ width: '100%' }} src={logoUrl} />}
    </a>
  );
});
